// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UVd3","right":"styles_right__3DapM"};